import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99759fda&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99759fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99759fda')) {
      api.createRecord('99759fda', component.options)
    } else {
      api.reload('99759fda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=99759fda&scoped=true&", function () {
      api.rerender('99759fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/drPurchase/index.vue"
export default component.exports